import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({ name, ...other }) {
  const { control } = useFormContext();

  // For pin field, add autocomplete disabling props
  const isPinField = name === 'pin';

  // Define props to add only for pin
  const pinAutoCompleteProps = isPinField
    ? {
        autoComplete: 'new-password',
        inputProps: {
          autoComplete: 'new-password',
          inputMode: 'numeric',
          pattern: '[0-9]*',
        },
      }
    : {};

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        // Remove value and InputProps from field if present in other
        const { value, InputProps, ...fieldRest } = field;
        const safeProps = {
          ...fieldRest,
          ...(other.value !== undefined ? { value: other.value } : { value }),
          ...(other.InputProps !== undefined ? { InputProps: other.InputProps } : {}),
        };
        return (
          <TextField
            {...safeProps}
            fullWidth
            error={!!error}
            helperText={error?.message}
            {...other}
            {...pinAutoCompleteProps}
          />
        );
      }}
    />
  );
}
